"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDynamicRechargeBundle = void 0;
var storefront_client_1 = require("@rechargeapps/storefront-client");
var buildDynamicRechargeBundle = function (_a) {
    var e_1, _b;
    var _c;
    var choices = _a.choices, mainRcBundleProduct = _a.mainRcBundleProduct, cdnBundleSettings = _a.cdnBundleSettings, shippingIntervalFrequency = _a.shippingIntervalFrequency, shippingIntervalUnitType = _a.shippingIntervalUnitType;
    var collectionId = Number(cdnBundleSettings.variants[0].option_sources[0].collection_id);
    var rechargeBundleData = {
        externalProductId: "".concat(mainRcBundleProduct.id),
        // We expect this product to have exactly one variant, and that's the one we care about
        externalVariantId: "".concat(mainRcBundleProduct.variants[0].id),
        selections: choices.map(function (choice) {
            var _a, _b;
            var choiceVariantId = choice.createItemParams[0];
            return {
                collectionId: "".concat(collectionId),
                externalProductId: "".concat(choice.variant.product.id),
                externalVariantId: "".concat(choiceVariantId),
                quantity: (_b = (_a = choice.createItemParams[1]) === null || _a === void 0 ? void 0 : _a.quantity) !== null && _b !== void 0 ? _b : 1,
                shippingIntervalFrequency: shippingIntervalFrequency,
                shippingIntervalUnitType: shippingIntervalUnitType,
                // If we don't provide this property, getDynamicBundleItems sets undefined as the id of each item. It's okay to have it equal to `externalVariantId`.
                discountedVariantId: choiceVariantId,
                // sellingPlan: item.selling_plan, // not needed for an RCS store like ours; only needed for an SCI store
            };
        }),
    };
    // This function puts some properties on each line item's 'properties' object so that recharge can tie the item to this bundle:
    // _rc_bundle, _rc_bundle_collection_id, _rc_bundle_parent, _rc_bundle_variant
    var items = (0, storefront_client_1.getDynamicBundleItems)(rechargeBundleData, mainRcBundleProduct.handle);
    // Finally, combine the properties from getDynamicBundleItems and the properties that were passed in via createItemParams
    // and build the CreateItemParams object that the cart expects.
    var parameters = [];
    var _loop_1 = function (item) {
        var choice = choices.find(function (c) {
            var choiceVariantId = c.createItemParams[0];
            var itemVariantId = Number(item.id);
            return choiceVariantId === itemVariantId;
        });
        if (!choice)
            throw new Error('Coding bug: cannot find choice in items');
        parameters.push([
            Number(item.id),
            {
                quantity: item.quantity,
                properties: __assign(__assign({}, (_c = choice.createItemParams[1]) === null || _c === void 0 ? void 0 : _c.properties), item.properties),
            },
        ]);
    };
    try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var item = items_1_1.value;
            _loop_1(item);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_b = items_1.return)) _b.call(items_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return parameters;
};
exports.buildDynamicRechargeBundle = buildDynamicRechargeBundle;
